import React from 'react';
import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import { injectTestId } from '@cvent/nucleus-test-automation';
import EmptyState from './EmptyState';

const useStyles = ({ isCompact }) => ({
  container: {
    marginTop: isCompact ? 0 : 115
  }
});

// Component displayed when no conversations have been started with other attendees
function EmptyChannelList({
  listType,
  variant = 'standard'
}: {
  listType?: 'channel' | 'message' | 'thread';
  variant?: 'compact' | 'standard';
}): JSX.Element {
  const isCompact = variant === 'compact';
  const styles = useStyles({ isCompact });

  if (listType === 'channel') {
    return (
      <Row justifyContent="center" {...injectTestId('attendee-messaging-empty-state-container')}>
        <Col padding={0} width={isCompact ? 1 : 0.8}>
          <div css={styles.container} {...injectTestId('attendee-messaging-empty-state-wrapper')}>
            <EmptyState flyoutStyle={isCompact} />
          </div>
        </Col>
      </Row>
    );
  }
  return null;
}

export default EmptyChannelList;
